export function searchTypeahead(endpoint, searchString) {
	const path = `${endpoint}?query=${searchString}`;

	return new Promise((resolve) => {
		fetch(path).then((response) => {
			response.json().then((json) => {
				resolve(json);
			});
		});
	});
}
